<template>
    <div class="flex">
       <button class="btn btn-sm btn-danger" @click="destroy_sick_leave()" onclick="this.parentNode.parentNode.parentNode.remove()"><i class="fas fa-trash-alt"></i></button>
    </div>
</template>

<script>
    export default {
        props: {
            sick_leave: {}
        },
        methods: {
            destroy_sick_leave: function () {
                let axios = require('axios');
                axios.delete('/employee/sick-leaves/' + this.sick_leave.id);
            }
        }
    }
</script>
